import { IsInt, IsString, IsOptional, IsNumber } from "class-validator";

export class GeoPoint {
  @IsNumber()
  @IsOptional()
  longitude!: number;
  @IsNumber()
  @IsOptional()
  latitude!: number;

  constructor(lat: number, long: number) {
    this.latitude = lat;
    this.longitude = long;
  }
}

// export class Telematic extends GeoPoint {
//   @IsString()
//   @IsOptional()
//   deviceID!: string;
//   @IsString()
//   @IsOptional()
//   timeStamp!: string;
//   @IsInt()
//   @IsOptional()
//   speedAvg!: number;
//   @IsInt()
//   @IsOptional()
//   speedMax!: number;
//   @IsInt()
//   @IsOptional()
//   course!: number;
//   @IsInt()
//   @IsOptional()
//   track!: number;
//   @IsInt()
//   @IsOptional()
//   altitude!: number;

//   fromCompact(arr: any[]) {
//     arr[0] = this.deviceID;
//     arr[1] = this.timeStamp;
//     arr[2] = this.longitude;
//     arr[3] = this.latitude;
//     arr[4] = this.speedAvg;
//     arr[5] = this.speedMax;
//     arr[6] = this.course;
//     arr[7] = this.track;
//     arr[8] = this.altitude;
//   }

//   toCompact(): any[] {
//     return [
//       this.deviceID,
//       this.timeStamp,
//       this.longitude,
//       this.latitude,
//       this.speedAvg,
//       this.speedMax,
//       this.course,
//       this.track,
//       this.altitude
//     ];
//   }
// }

export class GeoFilter {
  region?: GeoPoint[];

  zoom?: number;

  User_id?: number;

  // id машин
  vehicles?: number[] | null;

  // вид ТС - А, Тб, Тм
  vehicleTypes?: string[];

  // марка и модель ТС
  brandModels?: string[];

  statuses?: number[];

  // маршрут
  routes?: string[];

  // филлиалы
  branches?: number[];

  serialize() {
    let str = "";

    if (this.region) {
      str +=
        "@" +
        this.region
          .reduce((p, c) => `${p}${c.latitude}-${c.longitude},`, "")
          .slice(0, -1);
    }
    if (this.zoom) {
      str += "|z" + this.zoom;
    }
    if (this.vehicles) {
      str +=
        "|v" + this.vehicles.reduce((p, c) => `${p}${c},`, "").slice(0, -1);
    }
    if (this.vehicleTypes) {
      str +=
        "|t" + this.vehicleTypes.reduce((p, c) => `${p}${c},`, "").slice(0, -1);
    }

    if (this.brandModels) {
      str +=
        "|m" + this.brandModels.reduce((p, c) => `${p}${c},`, "").slice(0, -1);
    }

    if (this.routes) {
      str += "|r" + this.routes.reduce((p, c) => `${p}${c},`, "").slice(0, -1);
    }
    if (this.statuses) {
      str +=
        "|s" + this.statuses.reduce((p, c) => `${p}${c},`, "").slice(0, -1);
    }

    if (this.branches) {
      str +=
        "|b" + this.branches.reduce((p, c) => `${p}${c},`, "").slice(0, -1);
    }
    return encodeURIComponent(str);
  }
  deserialize(str: string) {
    const getPoint = (rs: string): GeoPoint => {
      const [lat, long] = rs.split("-");
      return new GeoPoint(parseFloat(lat), parseFloat(long));
    };

    const getSubPart = (str: string): string[] => str.split(",");

    const parts = str.split("|");
    if (parts.length > 0) {
      parts.forEach(p => {
        if (/^@/.test(p)) {
          this.region = getSubPart(p.replace("@", "")).map(s => getPoint(s));
        }
        if (/^z/.test(p)) {
          this.zoom = parseInt(p.replace(/^z/, ""));
        }
        if (/^v/.test(p)) {
          const v = p.replace(/^v/, "");
          if (v.length > 0) {
            this.vehicles = v.split(",").map(i => parseInt(i));
          }
        }
      });
    }
  }
}
